<div class="marine-insurance-payment-breakdown">
  <div class="marine-insurance-payment-breakdown-header">
    <div class="marine-insurance-payment-breakdown-header-text">
      {{ "LABELS.PAYMENT_BREAKDOWN" | translate }}
    </div>
  </div>

  <ng-container *ngIf="!isPendingPaymentState">
    <div class="marine-insurance-payment-breakdown-body" *ngIf="joinedItems?.length">
      <div class="row marine-insurance-payment-breakdown-body-row" *ngFor="let bill of joinedItems">
        <div class="col-8 marine-insurance-payment-breakdown-body-row-label">
          {{ bill?.description }}
          {{ bill.quantity > 1 ? " (x" + bill.quantity + ")" : "" }}
        </div>
        <div class="col-4 marine-insurance-payment-breakdown-body-row-value">
          {{ bill?.price * bill?.quantity || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
        </div>
      </div>
    </div>

    <div class="marine-insurance-payment-breakdown-footer" *ngIf="totalSum > 0">
      <div class="row mb-2">
        <div class="col-8 marine-insurance-payment-breakdown-body-row marine-insurance-payment-breakdown-footer-row-label">
          {{ "LABELS.TOTAL_PAYMENT" | translate }}
        </div>
        <div class="col-4 marine-insurance-payment-breakdown-footer-row-value">
          {{ totalSum | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isPendingPaymentState">
    <p>{{ "YOUR_FILING_IS_ON_HOLD" | translate }}</p>
  </ng-container>
</div>
